import React, { Fragment, Component } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import Spinner from '~/components/spinner/spinner';
import NotesCard from '~/components/notesCard/notesCard';
import TankDetailCard from '~/components/tankDetailCard/tankDetailCard';
import TankSummaryCard from '~/components/tankSummaryCard/tankSummaryCard';
import TankCurrentLotCard from '~/components/tankCurrentLotCard/tankCurrentLotCard';
import TitleBar from '~/components/titleBar/titleBar';
import MarkTankCleanModal from '~/containers/markTankCleanModal/markTankCleanModal';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getTankQuery = gql`
  query tank($id: Int!) {
    tank(id: $id) {
      id
      name
      notes
      type
      status
      volume
      currentLot {
        id
        reference
        startDate
        currentVolume
        volume
        isConsolidated
        transfers {
          name
          type
          tankType
          status
          transferDate
        }
      }
    }
  }
`;

export class Tank extends Component {
  state = {
    cleanModalOpen: false
  };

  toggleCleanModal = () => {
    this.setState({
      cleanModalOpen: !this.state.cleanModalOpen
    });
  };

  render() {
    const { onCompleted, id } = this.props;
    return (
      <Query query={getTankQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { tank } = data;

          const buttons = (
            <Fragment>
              {tank.status === 'REQUIRES_CLEANING' && (
                <Button className="mr3" color="secondary" onClick={this.toggleCleanModal}>
                  Set as cleaned
                </Button>
              )}
              <Link to={`/tanks/${tank.id}/edit`}>
                <Button color="primary">Edit</Button>
              </Link>
            </Fragment>
          );

          return (
            <Fragment>
              <TitleBar back="/tanks" backText="Tanks" title={tank ? tank.name : '...'} button={buttons} />
              <div className="flex content">
                <div className="flex-2 mr4">
                  <TankDetailCard {...tank} />
                  <TankCurrentLotCard currentLot={tank.currentLot} />
                </div>
                <div className="flex-1">
                  <TankSummaryCard {...tank} />
                  <NotesCard className="mt4" notes={tank.notes} />
                </div>
              </div>
              <MarkTankCleanModal
                tanks={[tank]}
                isOpen={this.state.cleanModalOpen}
                onSuccess={this.toggleCleanModal}
                onToggle={this.toggleCleanModal}
                refetchQueries={['tank']}
              />
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(Tank);



// WEBPACK FOOTER //
// ./src/containers/tank/tank.jsx